<template>
  <div>
    <div class="flex items-center mt-5">
      <p class="kit mx-2">{{ $t("OrderPage[\"Blood Kit\"]") }}</p>
    </div>
    <TubeTable id="blood-tube-table" :tube-data="tableDataBlood" :expanded="expanded" />
    <p class="kit mx-2 mt-5">{{ $t("OrderPage[\"Non-Blood Kit\"]") }}</p>
    <TubeTable id="nonblood-tube-table" :tube-data="tableDataNonBlood" :expanded="expanded" />
  </div>
</template>

<script>
import TubeTable from "./TubeTable.vue";
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  components: {
    TubeTable
  },
  props: {
    expanded: {
      type: Boolean,
      default: false
    },
    // tableData: {
    //   type: Array,
    //   default: null
    // },
    activateTube: {
      type: Boolean,
      default: () => false
    }, 
    tubeInfoForRequireTubeTabOrderSummary: {
      type: Object,
      default: () => {}
    },
    updatedTubeInfoCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      url: "@/assets/Info.svg",
      tableDataBlood: [],    
      tableDataNonBlood: [], 
    }
  },
  computed: {
    ...mapGetters("orderTest", ["orderItemListForApi"]),
    tubeMap() {
      return {
        DNA_FINGERPRICK: { name: [this.$t("OrderPage[\"DNA Dried Blood Spot Card\"]")], info: [''], png: ['dbs-card'], blood: false },
        SST: {
          name: [this.$t("OrderPage[\"Serum\"]")],
          info: [this.$t("OrderPage[\"(Tiger OR Red and yellow top SST)\"]")],
          png: ['sst-new-2'],
          blood: true,
          index: 0
        },
        EDTA: { name: ['EDTA'], info: [this.$t("OrderPage[\"(Lavender)\"]")], png: ['EDTA'], blood: true, index: 3 },
        METAL_FREE_URINE: { name: [this.$t("OrderPage[\"Urine\"]")], info: [''], png: ['urine-vwr-metal-free'], blood: false },
        TES: {
          name: [this.$t("OrderPage[\"Serum or SST X 2\"]"), this.$t("OrderPage[\"Metal-free transfer tube\"]")],
          info: [this.$t("OrderPage[\"(royal blue)\"]"), this.$t("OrderPage[\"(light blue label) labeled as 'TES'\"]")],
          png: ["royal", 'new-mn-transfer-tube'],
          blood: true,
          index: 1,
        },
        SODIUM_CITRATE_PLASMA: {
          name: [this.$t("OrderPage[\"Sodium Citrate\"]")],
          info: [this.$t("OrderPage[\"(Light Blue)\"]")],
          png: ['sct-light-blue-top'],
          blood: true,
          index: -1
        },
        BLOOD_FINGERPRICK: { name: [this.$t("OrderPage[\"DBS-Dried Blood Spot Card\"]")], info: [this.$t("OrderPage[\"(Standard)\"]")], png: ['dbs-card'], blood: false },
        STOOL: { name: [this.$t("OrderPage[\"Stool\"]")], info: [this.$t("OrderPage[\"(Orange)\"]")], png: ['parapak-stool-tube'], blood: false },
        SHIT: { name: [this.$t("OrderPage[\"Stool\"]")], info: [this.$t("OrderPage[\"(Orange)\"]")], png: ['parapak-stool-tube'], blood: false },
        UNPRESERVED_STOOL: { name: [this.$t("OrderPage[\"Clean Stool Vial\"]")], info: [this.$t("OrderPage[\"(White)\"]")], png: ['clean-vial'], blood: false },
        URINE_M: { name: [this.$t("OrderPage[\"Urine 1st Morning\"]")], info: [this.$t("OrderPage[\"(Waking)\"]")], png: ['urine-blue'], blood: false },
        URINE_A: {
          name: [this.$t("OrderPage[\"Urine 2 hours after waking\"]")],
          info: [this.$t("OrderPage[\"(Second Morning)\"]")],
          png: ['urine-yellow'],
          blood: false
        },
        URINE_E: { name: [this.$t("OrderPage[\"Urine Evening\"]")], info: [this.$t("OrderPage[\"(Before Bed)\"]")], png: ['urine-green'], blood: false },
        URINE_N: { name:[this.$t("OrderPage[\"Urine Night\"]")], info: [this.$t("OrderPage[\"(Before Bed)\"]")], png: ['urine-red'], blood: false },
        SALIVA_M: { name: [this.$t("OrderPage[\"Saliva\"]")], info: [this.$t("OrderPage[\"(Morning upon waking)\"]")], png: ['Saliva_M'], blood: false, index: 0 },
        SALIVA_MB: { name: [this.$t("OrderPage[\"Saliva\"]")], info: [this.$t("OrderPage[\"(Morning 60 min after waking)\"]")], png: ['Saliva_MB'], blood: false, index: 2 },
        SALIVA_MA: { name: [this.$t("OrderPage[\"Saliva\"]")], info: [this.$t("OrderPage[\"(Morning 30 min after waking)\"]")], png: ['Saliva_MA'], blood: false, index: 1 },
        SALIVA_I: { name: [this.$t("OrderPage[\"Saliva (Optional)\"]")], info: [this.$t("OrderPage[\"(Insomnia sample)\"]")], png: ['Saliva_I'], blood: false, index: 5 },
        SALIVA_A: {
          name: [this.$t("OrderPage[\"Saliva Afternoon\"]")],
          info: [this.$t("OrderPage[\"(Before Lunch)\"]")],
          png: ['saliva-tube-afternoon'], 
          blood: false
        },
        SALIVA_E: {
          name: [this.$t("OrderPage[\"Saliva\"]")],
          info: [this.$t("OrderPage[\"(Evening before Dinner)\"]")],
          png: ['Saliva_E'],
          index: 3,
          blood: false
        },
        SALIVA_N: { name: [this.$t("OrderPage[\"Saliva\"]")], info: [this.$t("OrderPage[\"(Night before Bed)\"]")], png: ['Saliva_N'], index: 4, blood: false },
        COVID19_FINGERPRICK: { name: [this.$t("OrderPage[\"Covid-19 Fingerprick\"]")], info: [''], png: ['dbs-card'], blood: false },
        COVID19_SST: { name: [this.$t("OrderPage[\"Covid-19 SST\"]")], info: [''], png: ['sst-new'], blood: true },
        COVID19_NPSWAB: { name: [this.$t("OrderPage[\"Covid-19 NP Swab\"]")], info: [''], png: ['covid-swab'], blood: false },
        PLASMA_EDTA: { 
          name: [this.$t("OrderPage[\"Tranfer tube\"]"), this.$t("OrderPage[\"Plasma EDTA X2\"]")], 
          info: ['(white)', ''], 
          png: ['transfer-tube', 'EDTA_X2'], 
          blood: true,
          qty_top: true,
        },
        PLASMA_EDTA_PLATELET_FREE: { 
          name: [this.$t("OrderPage[\"Tranfer tube\"]"), this.$t("OrderPage[\"Plasma EDTA Platelet Free X1\"]")], 
          info: [this.$t("OrderPage[\"(white)\"]"), ''], 
          png: ['transfer-tube', 'EDTA'], 
          blood: true,
          qty_top: true,
        },
        FROZEN_SERUM: { 
          name: [this.$t("OrderPage[\"Tranfer tube\"]"), this.$t("OrderPage[\"Serum X1\"]")],
          info: [this.$t("OrderPage[\"(white)\"]"), this.$t("OrderPage[\"(Red and yellow top SST)\"]")],
          png: ['transfer-tube', 'serum_X2'],
          blood: true ,
          qty_top: true,
        },
        PLASMA_CITRATE_PLATELET_POOR: {
          name: [this.$t("OrderPage[\"Tranfer tube\"]"), this.$t("OrderPage[\"Sodium Citrate X1\"]")],
          info: [this.$t("OrderPage[\"(white)\"]"), this.$t("OrderPage[\"(Light Blue) labeled\"]")],
          png: ['transfer-tube', 'sct-light-blue-top'],
          blood: true,
          qty_top: true,
        },
        PLASMA: {
          name: [this.$t("OrderPage[\"Lithium Heparin\"]")],
          info: [this.$t("OrderPage[\"(Light Green w/ plasma separator)\"]")],
          png: ['light-green-transfer-clear'], 
          blood: true,
          index: 2,
        },
        BLOOD_MICROTUBE: {
          name: [this.$t("OrderPage[\"Blood Microtube\"]")],
          info: [''],
          png: ['microtube'],
          blood: false
        },
        COVID_STOOL: {
          name: [this.$t("OrderPage[\"Saliva\"]")],
          info: [''],
          png: ['covid-stool'],
          blood: false
        },
        COVID19_STOOL: {
          name: [this.$t("OrderPage[\"Saliva\"]")],
          info: [''],
          png: ['covid-stool'],
          blood: false
        },    
        SALIVA: {
          name: [this.$t("OrderPage[\"Saliva\"]")],
          info: [''],
          png: ['covid-stool'],
          blood: false
        },
        URINE_UTI: {
          name: [this.$t("OrderPage[\"Urine UTI\"]")],
          info: [this.$t("OrderPage[\"Gray top, round bottom\"]")],
          png: ['urine_uti'],
          blood: false
        },
        URINE_ANALYSIS: {
          name: [this.$t("OrderPage[\"Urinalysis\"]")],
          info: [this.$t("OrderPage[\"Red/yellow top, conical bottom\"]")],
          png: ['urine_analysis'],
          blood: false
        }
      }
    }
  },
  watch: {
    updatedTubeInfoCount(newVal, oldVal) {
      if(newVal !== oldVal) {
        this.updateTableData(this.tubeInfoForRequireTubeTabOrderSummary)
      }
    },
    orderItemListForApi: _.debounce(function(newVal, oldVal) {
      if (!newVal || newVal.length === 0) {
        this.tableDataBlood = [];
        this.tableDataNonBlood = [];
        return
      }
    }
    , 600),
  },

  methods: {
    cellStyle() {
      return {
        padding: "0",
        color: "#999999",
        fontFamily: "Roboto",
        fontSize: "10px",
        letterSpacing: "0.29px",
        lineHeight:"11px",
        textAlign: "center"
      }
    },

    updateTableData(data) {
      let resBlood = [];
      let resNonBlood = [];
      let vol = data.volumeRequired;
      let tubeNormal = data.noOfTubes;
      let tubeDBS = data.noOfDbsBloodTubes;

      if (!_.isEmpty(tubeNormal)) {
        for(const [k, v] of Object.entries(tubeNormal)) {
          let tmp = {};
          tmp.key = k
          tmp.tube = []
          let { png, name, info, qty_top, blood, index } = this.tubeMap[k.toUpperCase()];
          if (png) {
            png.forEach(path => tmp.tube.push(path + ".png"));
          }
          tmp.specimenName = name;
          tmp.specimenInfo = info;
          tmp.qty = v;
          tmp.index = index;
          tmp.qty_top = !!qty_top;

          if (k in vol) {
            tmp.volume = `${vol[k]}ul`;
          } else {
            tmp.volume = "N/A";
          }
          tmp.note = "N/A";
          if (blood) {
            resBlood.push(tmp);
          } else {
            resNonBlood.push(tmp)
          }
        }
      }
      this.tableDataBlood = resBlood.sort((a, b) => {
        if (a.index !== undefined && b.index !== undefined) {
          return a.index - b.index;
        } else if (a.index === undefined) {
          return 1;
        } else {
          return -1; 
        }
      });
      this.tableDataNonBlood = resNonBlood.sort((a, b) => {
        if (a.index !== undefined && b.index !== undefined) {
          return a.index - b.index;
        } else if (a.index === undefined) {
          return 1;
        } else {
          return -1;
        }
      });
      return;
    }
  }
}
</script>

<style scoped>
.kit {
  color: var(--DividerGray, #C4C4C4);
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 12px;
  letter-spacing: 0.25px;
  text-transform: uppercase;
}
</style>
